import { useState } from "react"

import { useTranslation } from "react-i18next"

import type { FilthBackend } from "@/api/filth-backends-api"

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"

import { FilthEngineSettings } from "./filth-engine-settings"

export function FilthInstanceSettingsDialog({
  backend,
  onClose,
}: {
  backend: FilthBackend | null
  onClose: () => void
}) {
  const { t } = useTranslation()
  const [searchOverrides, setSearchOverrides] = useState(0)
  const [engineOverrides, setEngineOverrides] = useState(0)
  return (
    <Sheet
      open={backend !== null}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <SheetContent className="w-full overflow-y-auto p-6 sm:w-[92vw] sm:max-w-6xl sm:p-8">
        <SheetHeader className="gap-3 pr-6">
          <SheetTitle>
            {t("adminDashboard.filthSettings.dialogTitle", { name: backend?.name })}
          </SheetTitle>
          <SheetDescription className="max-w-prose leading-relaxed">
            {t("adminDashboard.filthSettings.dialogDescription")}
          </SheetDescription>
        </SheetHeader>
        {backend && (
          <div className="mt-8 space-y-6">
            <div className="flex flex-wrap items-center justify-between gap-4 rounded-lg border p-4">
              <p className="text-sm" role="status">
                {t("adminDashboard.filthSettings.overrideSummary", {
                  count: searchOverrides + engineOverrides,
                })}
              </p>
            </div>
            <FilthEngineSettings
              key={backend.id}
              combined
              id={backend.id}
              onOverridesChange={setEngineOverrides}
              onSearchOverridesChange={setSearchOverrides}
            />
          </div>
        )}
      </SheetContent>
    </Sheet>
  )
}
